export const FACTURATION = 'Facturation';
export const BAT = 'Bat';
export const AUTRE = 'Autre';

export const LISTE_TYPE_CONTACT_TYPE = [
  { libelle: 'addEditTypeContact.typeContactType.facturation', value: FACTURATION },
  { libelle: 'addEditTypeContact.typeContactType.bat', value: BAT },
  { libelle: 'addEditTypeContact.typeContactType.autre', value: AUTRE },
];
